export enum AdminCurrencyType {
  fiat = "fiat",
  crypto = "crypto",
}

export enum AdminCurrencyModalOption {
  create = "create",
  delete = "delete",
}
